<template>
  <modal  @leave="leave" :showCloseBtn="true">
    <div class="bg-tertiary text-secondary px-2 py-3 text-left rounded-t-lg mb-4">
      <h3 class="text-2xl leading-normal font-medium">Menus</h3>
    </div>

    <div class="overflow-scroll">
      <div class="text-left">
        <!-- Menu table -->
        <table class="table-auto w-full text-sm">
          <thead class="border-b uppercase text-xs">
            <th class="pb-3 font-semibold">Name</th>
            <th class="pb-3 font-semibold text-center">Actions</th>
            <th class="pb-3 font-semibold text-right">Order</th>
          </thead>
          <tbody>
            <template v-for="(menu, index) in menus">
               <tr :key="index + '-' + 'orderIndex'">
                <td></td>
                <td></td>
                <td class="text-right">
                   <button type="button" class="shadow-none p-1  hover:bg-grey-lighter border move-buttons" :disabled="index==0" @click="moveMenu(index,index-1)" :class="{ 'cursor-not-allowed hover:bg-white' : index==0 }">
                    <i class="fas fa-chevron-up"></i>
                  </button>
                  <button type="button" class="shadow-none p-1 hover:bg-grey-lighter border move-buttons" :disabled="index==(menus.length-1)" @click="moveMenu(index,index+1)" :class="{ 'cursor-not-allowed  hover:bg-white' : index==(menus.length-1) }">
                    <i class="fas fa-chevron-down"></i>
                  </button>
              </td>
              </tr>
              <MenuRow
                :key="componentKey + '-' + index"
                :id="menu.id"
                :name="menu.name"
                :parent="menu.parent"
                :slug="menu.slug"
                :type="menu.type"
                :guild_lite="menu.guild_lite"
                :assigned_network="menu.assigned_network"
                :assigned_countries="menu.assigned_countries"
                :country_list="menu.country_list"
                @createChild="addMenu(menu)"
                @save="save"
                @destroy="destroy(menu)"
              />
              <template  v-for="(childMenu, innerIndex) in menu.children">
                <tr :key="innerIndex + '-' + childMenu.id">
                  <td></td>
                  <td></td>
                  <td class="text-right">
                     <button type="button" class="shadow-none p-1  hover:bg-grey-lighter border move-buttons" :disabled="innerIndex==0" @click="moveChildMenu(index, innerIndex, innerIndex-1)" :class="{ 'cursor-not-allowed hover:bg-white' : innerIndex==0 }">
                      <i class="fas fa-chevron-up"></i>
                    </button>
                    <button type="button" class="shadow-none p-1 hover:bg-grey-lighter border move-buttons" :disabled="innerIndex==(menu.children.length-1)" @click="moveChildMenu(index, innerIndex, innerIndex+1)" :class="{ 'cursor-not-allowed  hover:bg-white' : innerIndex==(menu.children.length-1) }">
                      <i class="fas fa-chevron-down"></i>
                    </button>
                  </td>
                </tr>
                <MenuRow
                  :key="index + '-' + childMenu.id"
                  :id="childMenu.id"
                  :name="childMenu.name"
                  :slug="childMenu.slug"
                  :parent="menu.id"
                  :type="childMenu.type"
                  :guild_lite="menu.guild_lite"
                  :assigned_network="childMenu.assigned_network"
                  :assigned_countries="childMenu.assigned_countries"
                  :country_list="childMenu.country_list"
                  @create="addMenu(childMenu)"
                  @save="save"
                  @destroy="destroy(childMenu)"
                />
              </template>
            </template>
          </tbody>
        </table>

        <button
          type="button"
          @click="addMenu()"
          class="mt-4 mx-auto px-6 py-1 flex items-center justify-center text-sm text-grey-darkest rounded-lg border border-blue bg-white"
          :class="{ 'shadow-none opacity-50 cursor-not-allowed' : isAdding }"
          :disabled="isAdding"
        >
          <span class="text-lg mr-2">&#43;</span>
          Add Menu
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import api from '@/http'
import { head } from 'lodash'
import MenuRow from './MenuManager/MenuRow'

export default {
  components: {
    MenuRow
  },
  data () {
    return {
      isAdding: false,
      componentKey: 0
    }
  },

  computed: {
    ...mapState([
      'menus'
    ])
  },
  methods: {
    ...mapMutations([
      'updateMenus', 'deleteMenu'
    ]),

    ...mapActions([
      'displayToastNotification', 'deleteMenu'
    ]),

    head: head,

    addMenu (parent) {
      this.isAdding = true

      let menu = {
        name: null,
        type: null,
        slug: null,
        parent_id: parent ? parent.id : null
      }

      if (parent) {
        parent.children.push(menu)
      } else {
        this.updateMenus([...this.menus, { ...menu, children: [] }])
      }
    },

    save (menu) {
      this.$set(menu, 'isSaving', true)

      if (menu.id) {
        this.update(menu)
      } else {
        this.create(menu)
      }
    },

    create (menu) {
      api
        .post('menus', {
          name: menu.name,
          slug: menu.slug,
          parent_id: menu.parent,
          type: menu.type,
          guild_lite: menu.guild_lite,
          assigned_countries: menu.assigned_countries,
          assigned_network: menu.assigned_network
        })
        .then(response => {
          this.onSaveSuccess(menu, response)
        })
        .catch(error => this.onSaveError(menu, error.response))
    },

    update (menu) {
      api
        .patch(`menus/${menu.id}`, {
          name: menu.name,
          slug: menu.slug,
          parent_id: menu.parent,
          type: menu.type,
          guild_lite: menu.guild_lite,
          assigned_countries: menu.assigned_countries,
          assigned_network: menu.assigned_network
        })
        .then(response => this.onSaveSuccess(menu, response))
        .catch(error => this.onSaveError(menu, error.response))
    },

    destroy (menu) {
      if (menu.id) {
        api
          .delete(`menus/${menu.id}`)
          .then(response => {
            this.deleteMenu(menu)
            this.leave()
            this.displayToastNotification({
              type: 'success',
              icon: 'fa-check',
              title: 'Menu Deleted',
              info: `Menu "${menu.name}" has been successfully deleted.`
            })
          })
          .catch(error => {
            this.displayToastNotification({
              type: 'danger',
              icon: 'fa-exclamation',
              title: 'Unable to delete menu',
              info: error.response.data.message
            })
          })
      } else {
        this.isAdding = false
        this.deleteMenu(menu)
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Menu Deleted',
          info: menu.name ? `Menu "${menu.name}" has been successfully deleted.` : 'Menu has been successfully deleted'
        })
      }
    },

    onSaveSuccess (menu, response) {
      this.updateMenus(response.data)
      menu.isSaving = false
      menu.isEditing = false
      this.isAdding = false
      this.displayToastNotification({
        type: 'success',
        icon: 'fa-check',
        title: 'Page Saved',
        info: `Menu "${menu.name}" has been successfully saved.`
      })
    },

    onSaveError (menu, response) {
      menu.isSaving = false
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-bell',
        title: 'Unable to save menu',
        info: response.data.message
      })
    },

    leave () {
      this.$emit('leave')
      this.saveMenuOrder()
    },

    getFeatureList () {
      const features = {
        digitalHub: 'Digital Hub',
        insight: 'Insight',
        knowledgeHub: 'Knowledge Hub',
        partnerPages: 'Partner Pages',
        pom: 'Print Order Manager',
        propertyCms: 'Property CMS',
        propertyFeeds: 'Property Feeds',
        referrals: 'Referrals',
        webinars: 'Webinars',
        websiteCms: 'Website CMS',
        annualReview: 'Annual Review',
        qrGenerator: 'Custom QR Code Maker'
      }

      const response = []

      for (let key in features) {
        if (features.hasOwnProperty(key)) {
          response.push({
            name: features[key],
            slug: key
          })
        }
      }

      return response
    },
    moveMenu (from, to) {
      this.menus.splice(to, 0, this.menus.splice(from, 1)[0])
      this.componentKey += 1
    },
    moveChildMenu (menuIndex, fromIndex, toIndex) {
      if (toIndex >= 0 && toIndex < this.menus[menuIndex].children.length) {
        const childMenuItems = this.menus[menuIndex].children
        const movedItem = childMenuItems.splice(fromIndex, 1)[0]
        childMenuItems.splice(toIndex, 0, movedItem)
      }
    },
    saveMenuOrder () {
      api
        .post('menus/reorder', {
          menus: this.menus.map((menu, index) => ({ id: menu.id, children: menu.children }))
        })
        .then(() => {
        })
    }
  }
}
</script>
<style type="text/css" scoped>
  .move-buttons {
    position: relative;
    top: 42px !important;
  }
</style>
